import { render } from "./GridRescue.vue?vue&type=template&id=b119b2d8"
import script from "./GridRescue.vue?vue&type=script&lang=js"
export * from "./GridRescue.vue?vue&type=script&lang=js"

import "./GridRescue.vue?vue&type=style&index=0&id=b119b2d8&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__